import { exampleUser, User } from '../user/User';

export interface SupportTicketReply {
  id: number;
  body: string;
  user: User;
  createdAt: number;
  updatedAt: number;
}

export const exampleSupportTicketReply: SupportTicketReply = {
  id: 1,
  body: 'please help me',
  user: exampleUser,
  createdAt: +new Date() / 1000,
  updatedAt: +new Date() / 1000,
};
